import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { productsAPI, categoriesAPI } from '../../utils/api';
import { ProductCard, LoadingSpinner, EmptyState } from '../../components/common';

const ProductsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState('');

  const category = searchParams.get('category') || '';
  const search = searchParams.get('search') || '';

  useEffect(() => {
    categoriesAPI.getAll().then(r => setCategories(r.data));
  }, []);

  useEffect(() => {
    setLoading(true);
    productsAPI.getAll({ category, search, limit: 50 })
      .then(r => setProducts(r.data.products))
      .finally(() => setLoading(false));
  }, [category, search]);

  const handleAddToCart = (product) => {
    setToast(`${product.name} added to cart!`);
    setTimeout(() => setToast(''), 2000);
  };

  const setFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);
    if (value) params.set(key, value); else params.delete(key);
    setSearchParams(params);
  };

  return (
    <div className="container" style={{ padding: '1.5rem 1rem' }}>
      {toast && (
        <div className="alert alert-success" style={{ position: 'fixed', top: 70, right: 20, zIndex: 200, width: 'auto', minWidth: 200 }}>
          ✓ {toast}
        </div>
      )}

      <div className="page-header">
        <h1>Shop Supplies</h1>
        <p>Browse {products.length} products</p>
      </div>

      <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
        {/* Sidebar Filters */}
        <div style={{ width: 200, flexShrink: 0 }}>
          <div className="card">
            <h3 style={{ fontWeight: 700, marginBottom: '0.75rem', fontSize: '0.9rem' }}>Search</h3>
            <input
              className="form-input w-full"
              placeholder="Search products..."
              value={search}
              onChange={e => setFilter('search', e.target.value)}
            />

            <h3 style={{ fontWeight: 700, margin: '1rem 0 0.5rem', fontSize: '0.9rem' }}>Categories</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
              <button
                onClick={() => setFilter('category', '')}
                style={filterBtnStyle(!category)}
              >All Products</button>
              {categories.map(c => (
                <button
                  key={c.id}
                  onClick={() => setFilter('category', c.slug)}
                  style={filterBtnStyle(category === c.slug)}
                >
                  {c.icon} {c.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Grid */}
        <div style={{ flex: 1 }}>
          {loading ? (
            <LoadingSpinner />
          ) : products.length === 0 ? (
            <EmptyState icon="🔍" title="No products found" message="Try a different search or category" />
          ) : (
            <div className="grid-4">
              {products.map(p => (
                <ProductCard key={p.id} product={p} onAddToCart={handleAddToCart} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const filterBtnStyle = (active) => ({
  textAlign: 'left', padding: '0.4rem 0.65rem', borderRadius: 6, fontSize: '0.83rem',
  background: active ? '#dbeafe' : 'transparent', color: active ? '#1d4ed8' : '#374151',
  fontWeight: active ? 700 : 400, border: 'none', cursor: 'pointer', transition: 'background 0.15s',
});

export default ProductsPage;
